import { statusFormatterWithMap, textFormatter } from "components/Common/formatter";
import { STATUS_COLOR_MAP, TYPES_MAP } from "pages/price-management/Bundles/variables";
import React from "react";
import NGIDropdownButton from "components/Common/buttons/NGIDropdownButton";
import arrow from "assets/images/svg/arrow-white.svg";
import editPencil from "assets/images/svg/edit-pencil.svg";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import addCustomers from "assets/images/svg/add-customers.svg";
import removeCustomers from "assets/images/svg/remove-customers.svg";
import { USER_ROLES } from "utils/constants";

export const bundlesListColumns = (classes, history, approveDecline) => [
  {
    title: "Bundle ID",
    dataIndex: "id",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Display Name",
    dataIndex: "displayName",
  },
  {
    title: "Type",
    dataIndex: "type",
    render: cellContent => TYPES_MAP[cellContent],
  },
  {
    title: "Status",
    dataIndex: "status",
    render: value => statusFormatterWithMap(value, STATUS_COLOR_MAP),
  },
  {
    title: "LPG/Time",
    dataIndex: "lpgOrTime",
    render: textFormatter,
  },
  {
    title: "Duration",
    dataIndex: "validityPeriod",
    render: textFormatter,
  },
  {
    title: "Price",
    dataIndex: "price",
    render: textFormatter,
  },
  {
    title: "Start Date",
    dataIndex: "activationDate",
  },
  {
    title: "End Date",
    dataIndex: "deactivationDate",
  },
  {
    title: "Updated By",
    dataIndex: "updatedBy",
    render: cellData => (
      <div className={classes.overflowText} title={cellData}>
        {cellData}
      </div>
    ),
  },

  {
    title: "",
    width: "4%",
    key: "action",
    render: (_, row) => (
      <NGIDropdownButton
        position="left"
        toggleEl={<ButtonGroup icon={arrow} />}
        menuItems={[
          ...(row.status === "Active"
            ? [
                {
                  label: "View Details",
                  icon: editPencil,
                  callback: () => history.push(`bundles/${row.id}`),
                },
              ]
            : []),
          ...(row.status === "New"
            ? [
                {
                  label: "View Details",
                  icon: editPencil,
                  callback: () => history.push(`bundles/${row.id}`),
                },
              ]
            : []),
          ...(row.status === "Pending"
            ? [
                {
                  label: "View Details",
                  icon: editPencil,
                  callback: () => history.push(`bundles/${row.id}`),
                },
                {
                  label: "Approve Bundle",
                  icon: addCustomers,
                  callback: () => approveDecline(row, true),
                  roles: [USER_ROLES.SYSTEM_FULL_ADMINS, USER_ROLES.FINANCE],
                },
                {
                  label: "Decline Bundle",
                  icon: removeCustomers,
                  callback: () => approveDecline(row, false),
                  roles: [USER_ROLES.SYSTEM_FULL_ADMINS, USER_ROLES.FINANCE],
                },
              ]
            : []),
        ]}
      />
    ),
  },
];
